(function() {

	angular
		.module('ngmvac')
		.controller('AutoController', AutoController);

	AutoController.$inject = ['$scope', '$window', '$filter', 'AutoFactory', 'ReservationFactory', 'Cart'];

	function AutoController($scope, $window, filter, AutoFactory, ReservacionFactory, Cart) {
		var vm = this;

		vm.cart = Cart;
		vm.cart.config.editable = true;

		vm.total = 0;
		vm.autos = []; 
		vm.cotizador = {};
		vm.filter = {};
        vm.step = ($window.location.pathname == '/') ? 1 : (($window.location.pathname == '/autos/flota') ? 2 : 3);
        vm.link = (vm.step == 2) ? '/autos/datos' : '/hotel/reservacion'; 
		vm.places = ['Aeropuerto', 'Centro'];
		vm.loadFlota = true;

		AutoFactory.getHoras().then(function(response){
			vm.hours = response.data;
		});

		$scope.$on('cartLoaded', function(event, args) {
			vm.total = args.total;
			console.log(args);
		});

		$scope.$on('itemCartDeleted', function(event, args) {
			vm.total = args.total;
			if (vm.cart.content.length == 0)	{
				var container = angular.element('#cartCollapse');
				if (container.hasClass('cartFloat')) {
					container.addClass('hidden-xs').removeClass('cartFloat');
				}
			}

			swal(args.item[0].name + ' ha sido eliminado.', '', 'error');
		});

		vm.cart.init();

		AutoFactory.setTipo(vm.step);

		var params = { params : {}}
		AutoFactory.get(params)
			.then(function(response){
				if(vm.step == 2 || vm.step == 3){
					twoStepCars(response);
				}
			});

		$('#destino_auto').bind('typeahead:select', function(ev, data) {
			vm.iata 	= data.clave;
			vm.ciudad 	= data.ciudad;
		});

		var amountScrolled = 300;
        $(window).scroll(function() {
            if ($(window).scrollTop() > amountScrolled) {
                $('a.back-to-top').fadeIn('slow');
            } else {
                $('a.back-to-top').fadeOut('slow');
            }
        });

		// $('[data-toggle="popover"]').popover();

		function twoStepCars(response){
			vm.autos 		= response.data.flota;
			vm.cotizador 	= response.data.cotizador;
			// vm.cotizador.ciudad = vm.toTitleCase(vm.cotizador.ciudad);
			vm.backup 		= angular.copy(vm.autos);
			vm.brands 		= filter('brandsFilter')(vm.backup);
			vm.acriss 		= filter('acrissFilter')(vm.backup);
			vm.types 		= filter('carTypeFilter')(vm.backup);
			vm.iata 	 	= response.data.cotizador.IATA;
			vm.ciudad 		= response.data.cotizador.ciudad;
			console.log(vm.cotizador, "cotizador");
			console.log(vm.autos, "autos");
			$("#carTwoStepInicio").datepicker('update', vm.cotizador.fhInicio);
			$('#carTwoStepFin').datepicker('update', vm.cotizador.fhFin);
			$('#carTwoStepFin').datepicker('setStartDate', moment(vm.cotizador.fhInicio).add(1, 'days').format('YYYY-MM-DD'));
			$('#destino_auto').typeahead('val', vm.cotizador.ciudad);
			$('#loaderrese').hide();
		}

		vm.search = function(){
			vm.loadFlota = true;
			vm.autos.length = 0;

			var params = {
				params : {
					hora_pu     : vm.cotizador.hora_pu,
					hora_do     : vm.cotizador.hora_do,
					ubicacion   : vm.cotizador.ubicacion,
					ubicacion_do: vm.cotizador.ubicacion_do,
					IATA        : vm.iata,
					fhInicio    : moment( $('#carTwoStepInicio').val() ).format('YYYY-MM-DD'),
					fhFin       : moment( $('#carTwoStepFin').val() ).format('YYYY-MM-DD'),
				    step        : vm.step,
					ciudad 		: vm.ciudad
				}
			}

			AutoFactory.get(params).then(function(response){
				vm.autos 		= response.data.flota;
				vm.backup 		= angular.copy(vm.autos);
				vm.cotizador 	= response.data.cotizador;
				vm.brands 		= filter('brandsFilter')(vm.backup);
				vm.acriss 		= filter('acrissFilter')(vm.backup);
				vm.types 		= filter('carTypeFilter')(vm.backup);
			});
		}

		vm.booking = function(auto){
			var params = {
				params : {
					auto 	 : auto,
					cotizador: vm.cotizador
				}
			}

			AutoFactory.sessionStore(params).then(function(response){
				console.log(response);
				$window.location.href='/autos/datos';
			});

		}
		
		vm.brandFilter = function(){
			vm.autos = filter('searchBrandFilter')(vm.backup, vm.brands);
		}

		vm.acrissFilter = function(){
			vm.autos = filter('searchAcrissFilter')(vm.backup, vm.filter.acriss);
		}

		vm.carTypeFilter = function(){
			vm.autos = filter('searchCarTypeFilter')(vm.backup, vm.filter.carType);
		}

		vm.backToTop = function() {
            $('body,html').animate({
                scrollTop: 0
            }, 500);
            return false;
        }

		vm.toTitleCase = function(str)
		{
			return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
		}

		vm.addAuto = function (clickEvent, auto) {
			var DOMElement = angular.element(clickEvent.target);
			
			DOMElement
				.append(' <i class="fa fa-spin fa-spinner"></i>')
				.prop('disabled', true);;

			var startDateCP = vm.cotizador.fhInicio;
			var endDateCP = vm.cotizador.fhFin;
		
			var autoAdapter = {
				type: 'auto',
				name: auto.nombreAuto,
				description: auto.descripccion,
				caminoImagen: auto.imagenReal,
				proveedor: auto.id_proveedor,
				categoryCode: auto.id_categoria,
				categoryName: auto.categoria,
				startDate: startDateCP,
				endDate: endDateCP,
				idDatosDirectorioAbrir: auto.id_datos_directorio_abrir,//zoneName: '',
				idDatosDirectorioCerrar: auto.id_datos_directorio_cerrar, //destinationName: '',
				tracking: auto.tracking,
				images: [{
					path: auto.imagen,
					imageTypeCode: 'GEN'
				}],
				imagesProveedor: [{
					path: auto.imagenProveedor
				}],
				price: parseFloat(auto.pricePerDay) * parseInt(auto.totalDiasReservacion),
				discount: auto.discount,
				content: [{
					tarifa: auto.tarifaPublica,
					price: parseFloat(auto.precioFinal),
					net: auto.tarifaNeta,
					paxes: auto.cant_pasajeros,
					amount: 1,
					days: auto.totalDiasReservacion,
					promociones: auto.promociones
				}],
				loaded: false,
				currency: '',
				currencySymbol: '',
				cotizador: angular.copy(vm.cotizador)
			};

			angular.forEach(autoAdapter.content, function(content) {
				var totalPromociones = 0;
				angular.forEach(content.promociones, function(promocion) {
					totalPromociones += promocion.cantidad;
				});

				autoAdapter.price -= totalPromociones;
			});

			vm.cart.add(autoAdapter, function (item) {
				DOMElement
                    .prop('disabled', false)
                    .find('i')
                    .remove();
                swal(item.name + " agregado", "", "success");
			});	
			
			if (typeof auto.cupon !== 'undefined') {
				vm.cart.cupon = auto.cupon;
			}
		}

		vm.toggleCotizador = function() {
			if (angular.element('#cotizadorAutoCollapse').hasClass('hidden-xs')) {
                angular.element('#cotizadorAutoCollapse').removeClass('hidden-xs').addClass('cotizadorAutoFloat');
            } else {
                angular.element('#cotizadorAutoCollapse').addClass('hidden-xs').removeClass('cotizadorAutoFloat');
            }
		}

		vm.toggleCart = function() {
			if (angular.element('#cartCollapse').hasClass('hidden-xs')) {
                angular.element('#cartCollapse').removeClass('hidden-xs').addClass('cartFloat');
            } else {
                angular.element('#cartCollapse').addClass('hidden-xs').removeClass('cartFloat');
            }
		}
	}
})();
